import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Switch } from "@/components/ui/switch";
import { toast } from "sonner";
import { Save } from "lucide-react";
import { updateVzDigestConfig, updateVzDealerCc } from "@/lib/verizonSalesApi";

const split = (t) => t.split(/[\s,;]+/).map((x) => x.trim()).filter(Boolean);

export const DigestCcSettings = ({ cfg, onSaved }) => {
  const [cc, setCc] = useState((cfg.cc || []).join(", "));
  const save = async (patch) => {
    try { onSaved(await updateVzDigestConfig(patch)); toast.success("Recipients saved"); }
    catch (e) { toast.error(e.response?.data?.detail || "Save failed"); }
  };
  return (
    <div className="border border-slate-200 rounded-lg p-3 space-y-3" data-testid="vz-digest-cc-settings">
      <div className="text-xs font-semibold text-slate-600">Recipients (every dealer email)</div>
      <div className="flex flex-wrap gap-6 text-xs">
        <label className="flex items-center gap-2"><Switch checked={cfg.include_rpm} onCheckedChange={(v) => save({ include_rpm: v })} data-testid="vz-digest-rpm-switch" /> CC each store's RPM Email (DLAR)</label>
        <label className="flex items-center gap-2"><Switch checked={cfg.include_sm} onCheckedChange={(v) => save({ include_sm: v })} data-testid="vz-digest-sm-switch" /> CC each store's SM Email (DLAR, skips "MA Rep")</label>
      </div>
      <div className="flex gap-2 items-end">
        <label className="flex-1 text-xs text-slate-600">Prime Media CC (comma separated)
          <Input className="h-9 mt-1 text-xs" value={cc} onChange={(e) => setCc(e.target.value)} data-testid="vz-digest-cc-input" />
        </label>
        <Button size="sm" onClick={() => save({ cc: split(cc) })} data-testid="vz-digest-cc-save"><Save className="w-4 h-4 mr-1" /> Save</Button>
      </div>
    </div>
  );
};

export const DealerCcEditor = ({ dealer, onSaved }) => {
  const [extra, setExtra] = useState((dealer.extra_cc || []).join(", "));
  const [exclude, setExclude] = useState((dealer.exclude || []).join(", "));
  const save = async () => {
    try { await updateVzDealerCc({ dealer_id: dealer.id, extra_cc: split(extra), exclude: split(exclude) }); toast.success("Dealer CC saved"); onSaved(); }
    catch (e) { toast.error(e.response?.data?.detail || "Save failed"); }
  };
  return (
    <div className="border border-slate-200 rounded-lg p-3 space-y-2 text-xs" data-testid="vz-digest-dealer-cc">
      <div><span className="font-semibold text-slate-600">To:</span> {dealer.to.join(", ") || <span className="text-red-600">no valid dealer email</span>}</div>
      <div data-testid="vz-digest-dealer-cc-list"><span className="font-semibold text-slate-600">CC:</span> {dealer.cc.join(", ") || "none"}</div>
      <div className="grid md:grid-cols-2 gap-2">
        <label className="text-slate-600">Extra CC for this dealer
          <Input className="h-8 mt-1 text-xs" value={extra} onChange={(e) => setExtra(e.target.value)} placeholder="name@company.com" data-testid="vz-digest-extra-cc" />
        </label>
        <label className="text-slate-600">Don't CC for this dealer
          <Input className="h-8 mt-1 text-xs" value={exclude} onChange={(e) => setExclude(e.target.value)} placeholder="rep@verizon.com" data-testid="vz-digest-exclude-cc" />
        </label>
      </div>
      <Button size="sm" variant="outline" onClick={save} data-testid="vz-digest-dealer-cc-save"><Save className="w-4 h-4 mr-1" /> Save dealer CC</Button>
    </div>
  );
};
